export default __webpack_public_path__ + "static/media/logo-dark.a347632e.png";